<template>
  <div>
    <div
      class="media-image-viewer-layout__background"
      :style="{ backgroundImage: `url('${imageUrl}')` }"
    />
    <img
      :src="imageUrl"
      class="media-image-viewer-layout__image"
      data-test-id="MediaImageViewerLayout_Image"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    imageUrl: {
      type: String,
      required: true,
    },
  },
})
</script>

<style lang="postcss">
.media-image-viewer-layout {
  &__image {
    max-width: 100%;
    max-height: 50vh;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
  }

  &__background {
    pointer-events: none;
    position: absolute;
    top: 0;
    height: 100%;
    width: 100%;
    background-size: cover;
    background-position: center;
    opacity: 0.1;
  }
}
</style>
